import React from 'react'
import sqfeet1000 from "../images/1000 sq.jpg";
import sqfeet2000 from "../images/2000 sqft.jpg";
import sqfeet4000 from "../images/4000sqft.jpg"
const phoneNumber = "917550967009"; // 👉 Your number with country code
const message = "Hello, I want to know more about your services";

const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
};

function Projectpage() {
    return (
        <div>
            <div className="album py-1">
                <div className="container mt-3">
                    <center>
                        <h1><b>Book Your Dream Plot at Unicorn Aerocity
                        </b></h1>
                        <p>Unicorn Aerocity by Novesta Group offers premium residential plots near Kolkata Airport.</p>
                    </center>

                </div>
            </div>
            <div className="album py-2">
                <div className="container">
                    <div className="row ">
                        <div className="col-md-4 mt-2">
                            <div class="card">
                                <img src={sqfeet1000} className="card-img-top" alt="sqfeet1000" />

                                <div className="card-body">
                                    <h2 style={{ color: '#18444c' }} className="card-title mb-3">1000 Sqft Plot</h2>
                                    <h6>Compact Villa Plot</h6>
                                    <h5 className='mb-3'>Booking Amount: ₹1,00,000</h5>
                                    <div className="d-flex justify-content-between align-items-center mb-0">
                                        <a className='call' href='tel: 7550967009'>Call Now</a>
                                        <button onClick={handleClick} className='whatsapp'>
                                            Chat on WhatsApp
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2">
                            <div className="card">


                                <img src={sqfeet2000} className="card-img-top" alt="sqfeet2000" />

                                <div className="card-body">
                                    <h2 style={{ color: '#18444c' }} className="card-title mb-3">2000 Sqft Plot</h2>
                                    <h6>Luxury Villa Plot</h6>
                                    <h5 className='mb-3'>Booking Amount: ₹1,00,000</h5>
                                    <div className="d-flex justify-content-between align-items-center mb-0">
                                        <a className='call' href='tel: 7550967009'>Call Now</a>
                                        <button onClick={handleClick} className='whatsapp'>
                                            Chat on WhatsApp
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={sqfeet4000} className="card-img-top" alt="sqfeet4000" />

                                <div class="card-body">
                                    <h2 style={{ color: '#18444c' }} className="card-title mb-3">4000 Sqft Plot</h2>
                                    <h6>Premium Villa Plot</h6>
                                    <h5 className='mb-3'>Booking Amount: ₹2,00,000</h5>
                                    <div className="d-flex justify-content-between align-items-center mb-0">
                                        <a className='call' href='tel: 7550967009'>Call Now</a>
                                        <button onClick={handleClick} className='whatsapp'>
                                            Chat on WhatsApp
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />

        </div>
    )
}

export default Projectpage